import {
  PrimaryRegularButton,
  SecondaryRegularButton
} from 'components/ReusableComponents/Button/RegularButtons'
import TextInput from 'components/ReusableComponents/ManageHotel/TextInput'
import { useEmailEditor } from 'features/EmailEditor/EmailEditorContext'
import { useState } from 'react'
import { useToasts } from 'react-toast-notifications'

import styles from './EmailEditor.module.scss'

const TestEmail = () => {
  const { currentUser, sendTestEmail } = useEmailEditor()

  const { addToast } = useToasts()

  const [emailToSend, setEmailToSend] = useState(currentUser.email)
  const [isSending, setIsSending] = useState(false)

  const handleSendTestEmail = () => {
    if (isSending) {
      return
    }

    setIsSending(true)

    sendTestEmail(emailToSend)
      .then(() => {
        addToast('Test email sent successfully!', { appearance: 'success' })
      })
      .catch(() => {
        addToast('Failed to send test email.', { appearance: 'error' })
      })
      .finally(() => {
        setIsSending(false)
      })
  }

  return (
    <div className={styles.emailTestHolder}>
      <p className={styles.emailTestTitle}>Test your email</p>
      <div className={styles.emailTestForm}>
        <TextInput
          type="email"
          value={emailToSend}
          onChangeValue={value => setEmailToSend(value)}
          disabled={isSending}
        />
        <SecondaryRegularButton onClick={handleSendTestEmail} disabled={isSending}>
          {isSending ? 'Sending...' : 'Send Test Email'}
        </SecondaryRegularButton>
      </div>
    </div>
  )
}

export default TestEmail
